import React, { useState, useEffect } from 'react';
import './Order.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash,faIndianRupeeSign  } from '@fortawesome/free-solid-svg-icons';
const defaultItems = [
    {
        "name": "బియ్యం",
        "unit": "Kg",
        "category": "కిరాణా వస్తువులు",
        "image": "https://img500.exportersindia.com/product_images/bc-500/dir_181/5428832/rice-bags-1515756843-3576043.jpeg", // base64 data URL
        "variants": [
            { "size": "1Kg", "rate": 50 },
            { "size": "5Kg", "rate": 245 },
            { "size": "10Kg", "rate": 480 }
        ]
    },
    {
        "name": "నువ్వుల నూనె",
        "unit": "Ltr",
        "category": "కిరాణా వస్తువులు",
        "image": "https://img3.exportersindia.com/product_images/bc-small/2022/6/9673359/watermark/iyal-500ml-cold-pressed-sesame-oil-1655704307-6403015.jpeg", // base64 data URL
        "variants": [
            { "size": "1L", "rate": 130 },
            { "size": "5L", "rate": 640 }
        ]
    },
    {
        "name": "ఉప్పు",
        "unit": "Kg",
        "category": "కిరాణా వస్తువులు",
        "image": "https://img2.exportersindia.com/product_images/bc-small/dir_181/5419084/tata-salt-1514966381-3557078.jpeg", // base64 data URL
        "variants": [
            { "size": "1Kg", "rate": 20 },
            { "size": "5Kg", "rate": 95 }
        ]
    },
    {
        name: "పసుపు పొడి",
        unit: "Kg",
        category: "కిరాణా వస్తువులు",
        image: "https://m.media-amazon.com/images/I/812sgSnc3aL._UF894%2C1000_QL80_.jpg", // turmeric powder packet
        variants: [
            { size: "100g", rate: 23 },
            { size: "250g", rate: 55 },
            { size: "500g", rate: 110 },
            { size: "1Kg", rate: 222.5 }
        ]
    },
    {
        name: "మిరియాల పొడి",
        unit: "Kg",
        category: "కిరాణా వస్తువులు",
        image: "https://m.media-amazon.com/images/I/81xMTQInyML.jpg", // black pepper powder packet
        variants: [
            { size: "100g", rate: 45 },
            { size: "250g", rate: 100 },
            { size: "500g", rate: 200 },
            { size: "1Kg", rate: 400 }
        ]
      },
    {
        "name": "తుర్ దాల్",
        "unit": "Kg",
        "category": "కిరాణా వస్తువులు",
        image: "https://ranibrand.com/cdn/shop/files/680901085902RaniToorDal8lbsfront.jpg?v=1698140230", // black pepper powder packet
        "rate": 35
    },
    {
        "name": "Santoor సబ్బు",
        "unit": "Pcs",
        "category": "సబ్బులు",
        image: "https://m.media-amazon.com/images/I/51gzT-GgYUL._UF1000%2C1000_QL80_.jpg", // black pepper powder packet
        "variants": [
            { "size": "75g", "rate": 35 },
            { "size": "125g", "rate": 60 }
        ]
    },
    {
        "name": "Dettol సబ్బు",
        "unit": "Pcs",
        "category": "సబ్బులు",
        image: "https://m.media-amazon.com/images/I/61ccLahWqHL.jpg", // black pepper powder packet
        "variants": [
            { "size": "70g", "rate": 38 },
            { "size": "125g", "rate": 68 }
        ]
    },
    {
        "name": "Lifeboy హ్యాండ్‌వాష్",
        "unit": "Pcs",
        "category": "సబ్బులు",
        image: "https://m.media-amazon.com/images/I/61ndHUqpqfL.jpg", // black pepper powder packet
        "variants": [
            { "size": "200ml", "rate": 45 },
            { "size": "500ml", "rate": 110 }
        ]
    },
    {
        "name": "Clinic Plus షాంపూ",
        "unit": "Pcs",
        "category": "షాంపూలు",
        image: "https://m.media-amazon.com/images/I/515KKnjDcZL._UF1000%2C1000_QL80_.jpg", // black pepper powder packet
        "variants": [
            { "size": "100ml", "rate": 50 },
            { "size": "200ml", "rate": 95 },
            { "size": "400ml", "rate": 180 }
        ]
    },
    {
        "name": "Head & Shoulders షాంపూ",
        "unit": "Pcs",
        "category": "షాంపూలు",
        image: "https://images.ctfassets.net/96bre0uq5ome/6vG4LkdjuCqWrXyQilSmI6/fe87163f7aaef1d31ef4cefc750d2ed4/HeadShoulders_-SH_Charcoal_front.png", // black pepper powder packet
        "variants": [
            { "size": "80ml", "rate": 60 },
            { "size": "180ml", "rate": 110 },
            { "size": "360ml", "rate": 210 }
        ]
    },
    {
        "name": "Himalaya ఫేస్ వాష్",
        "unit": "Pcs",
        "category": "ఫేస్ వాష్ & క్రీములు",
        image: "https://m.media-amazon.com/images/I/81iagtr9c3L._UF1000%2C1000_QL80_.jpg", // black pepper powder packet
        "variants": [
            { "size": "50ml", "rate": 50 },
            { "size": "100ml", "rate": 90 },
            { "size": "150ml", "rate": 130 }
        ]
    },
    {
        "name": "Fair & Lovely క్రీమ్",
        "unit": "Pcs",
        "category": "ఫేస్ వాష్ & క్రీములు",
        image: "https://imageio.forbes.com/specials-images/imageserve/165323482/0x0.jpg?fit=bounds&format=jpg&height=900&width=1600", // black pepper powder packet
        "variants": [
            { "size": "25g", "rate": 30 },
            { "size": "50g", "rate": 65 },
            { "size": "80g", "rate": 100 }
        ]
    },
    {
        "name": "Colgate పేస్ట్",
        "unit": "Pcs",
        "category": "పేస్టులు",
        image: "https://i.ebayimg.com/images/g/epkAAOSw6VxnPziA/s-l1200.jpg", // black pepper powder packet
        "variants": [
            { "size": "50g", "rate": 30 },
            { "size": "100g", "rate": 55 },
            { "size": "150g", "rate": 75 }
        ]
    },
    {
        "name": "Vim లిక్విడ్",
        "unit": "Pcs",
        "category": "డిష్ వాషర్లు",
        image: "https://m.media-amazon.com/images/I/51rhw--KcDL._UF1000%2C1000_QL80_.jpg", // black pepper powder packet
        "variants": [
            { "size": "250ml", "rate": 25 },
            { "size": "500ml", "rate": 50 },
            { "size": "1L", "rate": 95 }
        ]
    },
    {
        "name": "Pril లిక్విడ్",
        "unit": "Pcs",
        "category": "డిష్ వాషర్లు",
        image: "https://m.media-amazon.com/images/I/61t8-gI5R1L.jpg", // black pepper powder packet
        "variants": [
            { "size": "250ml", "rate": 28 },
            { "size": "500ml", "rate": 55 },
            { "size": "1L", "rate": 100 }
        ]
    },
    {
        "name": "Harpic టాయిలెట్ క్లీనర్",
        "unit": "Pcs",
        "category": "టాయిలెట్ క్లీనర్లు",
        image: "https://m.media-amazon.com/images/I/61-jfxZ4VJL.jpg", // black pepper powder packet
        "variants": [
            { "size": "200ml", "rate": 38 },
            { "size": "500ml", "rate": 70 },
            { "size": "1L", "rate": 135 }
        ]
    },
    {
        "name": "Lizol ఫ్లోర్ క్లీనర్",
        "unit": "Pcs",
        "category": "టాయిలెట్ క్లీనర్లు",
        image:"https://i5.walmartimages.com/seo/Lizol-Disinfectant-Surface-Floor-Cleaner-Liquid-Floral-625ml_357827a9-5f35-4ec1-ba08-de303dbffb98.479d03272d6baecdc904a6538a2d39e3.jpeg",
        "variants": [
            { "size": "500ml", "rate": 95 },
            { "size": "1L", "rate": 175 }
        ]
    },
    {
        "name": "Sunlight వాషింగ్ పౌడర్",
        "unit": "Kg",
        "category": "వాషింగ్ పౌడర్లు",
        image: "https://i.ebayimg.com/images/g/nekAAOSwIftgJkjw/s-l1200.jpg",
        "variants": [
            { "size": "500g", "rate": 30 },
            { "size": "1Kg", "rate": 60 },
            { "size": "2Kg", "rate": 115 }
        ]
    },
    {
        "name": "Red Label టీ",
        "unit": "Pcs",
        "category": "టీ పౌడర్లు",
        image: "https://m.media-amazon.com/images/I/41-X8UFzPvL._AC_.jpg",
        "variants": [
            { "size": "100g", "rate": 60 },
            { "size": "250g", "rate": 120 },
            { "size": "500g", "rate": 230 },
            { "size": "1Kg", "rate": 480 }
        ]
    },
    {
        "name": "Taj Mahal టీ",
        "unit": "Pcs",
        "category": "టీ పౌడర్లు",
        image: "https://m.media-amazon.com/images/I/71ICY5RlcZL.jpg",
        "variants": [
            { "size": "250g", "rate": 135 },
            { "size": "500g", "rate": 270 },
            { "size": "1Kg", "rate": 520 }
        ]
    },
    {
        "name": "Good Day బిస్కెట్",
        "unit": "Pcs",
        "category": "బిస్కెట్లు & చిప్స్",
        image: "https://m.media-amazon.com/images/I/61INGvZ3CVL.jpg",
        "variants": [
            { "size": "Small", "rate": 10 },
            { "size": "Large", "rate": 25 }
        ]
    },
    {
        "name": "Lays చిప్స్",
        "unit": "Pcs",
        "category": "బిస్కెట్లు & చిప్స్",
        image: "https://i5.walmartimages.com/seo/Lay-s-Classic-Potato-Chips-Party-Size-13-oz-Bag_066afffd-49e9-4d1c-abb4-3cdce85da3f0.43865a58381c82680d373ec7449460e4.jpeg",
        "variants": [
            { "size": "25g", "rate": 10 },
            { "size": "50g", "rate": 20 },
            { "size": "90g", "rate": 35 }
        ]
    }
]
  
const rawCategories = [...new Set(defaultItems.map(item => item.category))];
const categories = ["All", ...rawCategories];

export default function Order() {
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [allItems, setAllItems] = useState(() => {
        const saved = localStorage.getItem('savedItems');
        return saved
            ? JSON.parse(saved)
            : defaultItems.map(item => ({
                ...item,
                qty: 0,
                total: 0
            }));
    });
    const [items, setItems] = useState([]);
    const [swipeIndex, setSwipeIndex] = useState(null);
    const [touchStartX, setTouchStartX] = useState(0);
    const [touchDeltaX, setTouchDeltaX] = useState(0);

    const [showModal, setShowModal] = useState(false);
    const [modalItemIndex, setModalItemIndex] = useState(null);
    const [modalQty, setModalQty] = useState('');

    const [variantModalItem, setVariantModalItem] = useState(null);

    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        localStorage.setItem('savedItems', JSON.stringify(allItems));
    }, [allItems]);

    useEffect(() => {
        const filtered = selectedCategory === "All"
            ? allItems
            : allItems.filter(item => item.category === selectedCategory);
        setItems(filtered);
    }, [selectedCategory, allItems]);

    const handleCategoryChange = (cat) => {
        setSelectedCategory(cat);
        setSwipeIndex(null);
    };

    const openQtyModal = (index) => {
        setModalItemIndex(index);
        setModalQty(items[index].qty);
        setShowModal(true);
    };

    const confirmQtyChange = () => {
        const newQty = modalQty === '' ? 0 : Math.max(0, parseFloat(modalQty) || 0);
        const itemName = items[modalItemIndex].name;
        setAllItems(allItems.map(item =>
            item.name === itemName
                ? { ...item, qty: newQty, total: newQty * item.rate }
                : item
        ));
        setShowModal(false);
        setModalItemIndex(null);
    };

    const handleTouchStart = e => setTouchStartX(e.touches[0].clientX);
    const handleTouchMove = e => {
        const delta = e.touches[0].clientX - touchStartX;
        if (delta < 0) setTouchDeltaX(delta);
    };
    const handleTouchEnd = i => {
        if (Math.abs(touchDeltaX) > 50) setSwipeIndex(i);
        else setSwipeIndex(null);
        setTouchDeltaX(0);
    };

    const handleDelete = (i) => {
        const itemName = items[i].name;
        setAllItems(allItems.filter(item => item.name !== itemName));
        setSwipeIndex(null);
    };

    const handleDone = () => {
        setAllItems(defaultItems.map(item => ({
            ...item, qty: 0, total: 0
        })));
        setSelectedCategory("All");
        localStorage.removeItem('savedItems');
        setShowPopup(true);
    };
    const closePopup = () => setShowPopup(false);

    const grandTotal = allItems.reduce((sum, i) => sum + i.total, 0);

    const handleItemClick = (i) => {
        const clicked = items[i];
        if (clicked.variants) {
            setVariantModalItem(clicked);
        } else {
            setAllItems(allItems.map(item =>
                item.name === clicked.name
                    ? { ...item, qty: item.qty + 1, total: (item.qty + 1) * item.rate }
                    : item
            ));
        }
    };

    const addVariant = (variant) => {
        const base = variantModalItem;
        const name = `${base.name} (${variant.size})`;
        const existing = allItems.find(item => item.name === name);
        const baseIndex = allItems.findIndex(item => item.name === base.name);
        let updated = [...allItems];

        if (existing) {
            updated = updated.map(item =>
                item.name === name
                    ? { ...item, qty: item.qty + 1, total: (item.qty + 1) * item.rate }
                    : item
            );
        } else {
            const variantItem = {
                name,
                image: base.image,
                unit: base.unit,
                rate: variant.rate,
                category: base.category,
                qty: 1,
                total: variant.rate
            };
            // Insert variant right after the base item
            updated.splice(baseIndex + 1, 0, variantItem);
        }

        setAllItems(updated);
        setVariantModalItem(null);
    };
      
    return (
        <div className="table-wrapper-blue-onlineorder">
            <div className="category-scroll-onlineorder">
                {categories.map((cat, idx) => (
                    <div key={idx}
                        className={`category-title-onlineorder ${selectedCategory === cat ? 'active-onlineorder' : ''}`}
                        onClick={() => handleCategoryChange(cat)}>
                        {cat}
                    </div>
                ))}
            </div>

            {items.length > 0 && (
                <>
                    <div className="header-row-onlineorder">
                        <div className="col-onlineorder name-onlineorder">సరకులు</div>
                        <div className="col-onlineorder qty-onlineorder">క్వాంటిటీ</div>
                    </div>

                    <div className="scroll-container-onlineorder">
                        {items.map((item, i) => (
                            <div key={i}
                                className="swipe-wrapper-onlineorder"
                                onTouchStart={handleTouchStart}
                                onTouchMove={handleTouchMove}
                                onTouchEnd={() => handleTouchEnd(i)}
                                onClick={() => handleItemClick(i)}
                            >
                                <div className="delete-slide-onlineorder">
                                    <button className="delete-btn-onlineorder" onClick={() => handleDelete(i)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </div>
                                <div className={`swipe-item-onlineorder ${swipeIndex === i ? 'swiped-onlineorder' : ''}`}>
                                    <div className="item-content-onlineorder">
                                        <div className="item-row-onlineorder">
                                            <div className="col-onlineorder name-onlineorder">
                                                {item.image && (
                                                    <img src={item.image} alt={item.name} className="product-thumb" />
                                                )}
                                                {item.name}
                                            </div>
                                            <div className="col-onlineorder qty-onlineorder">
                                                <input type="text" className="qty-input-onlineorder"
                                                    readOnly value={item.qty} onClick={() => openQtyModal(i)} />
                                                <span className="unit-onlineorder">{item.unit}</span>
                                            </div>
                                        </div>
                                        {item.qty !== 0 && (
                                            <div className="calc-row-onlineorder">
                                                <div className="rate_item">
                                                    {item.qty} × {item.rate} = {(item.total % 1 === 0 ? item.total : item.total.toFixed(2))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}

            {items.length > 0 && (
                <div className="footer-total-onlineorder">
                    <div className="total-left-onlineorder">
                        <strong>Total:</strong> <FontAwesomeIcon icon={faIndianRupeeSign} /> {grandTotal.toFixed(2)}
                    </div>
                    <button className="done-btn-onlineorder" onClick={handleDone}>Submit</button>
                </div>
            )}

            {showModal && modalItemIndex !== null && (
                <div className="modal-overlay-onlineorder">
                    <div className="modal-box-onlineorder">
                        <h3>{items[modalItemIndex].name}</h3>
                        <input type="number" value={modalQty}
                            onChange={e => setModalQty(e.target.value)}
                            className="modal-input-onlineorder"
                            step="any" inputMode="decimal" />
                        <div className="modal-actions-onlineorder">
                            <button onClick={() => setShowModal(false)}>Cancel</button>
                            <button onClick={confirmQtyChange}>OK</button>
                        </div>
                    </div>
                </div>
            )}

            {variantModalItem && (
                <div className="modal-overlay-onlineorder">
                    <div className="modal-box-onlineorder">
                        <h3>{variantModalItem.name} – Select </h3>
                        <ul className="variant-list">
                            {variantModalItem.variants.map((v, idx) => (
                                <li key={idx}>
                                    <button onClick={() => addVariant(v)}>
                                        {v.size} – ₹{v.rate}
                                    </button>
                                </li>
                            ))}
                        </ul>
                        <button className='cancel-onlineorder' onClick={() => {
                            setVariantModalItem(null);
                            setShowModal(false);
                        }}
>Cancel</button>
                    </div>
                </div>
            )}

            {showPopup && (
                <div className="modal-overlay-onlineorder">
                    <div className="modal-box-onlineorder sucess-order">
                        <h3>మీ ఆర్డర్ విజయవంతంగా నమోదైంది!</h3>
                        <div className="modal-actions-onlineorder">
                            <button onClick={closePopup}>సరే</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}